<template>
	<div>
		<label class="label-form">{{labelText}}</label>
		<v-select
			class="filter-select filter-select filter-select-autocomplete"
			hide-details
			:value="value"
			v-bind="$attrs"
			@input="sendValue"
			@change="changeValue"
			single-line
		/>
	</div>
</template>

<script>

function sendValue(value) {
	this.$emit('input', value);
}

function changeValue(value) {
	this.$emit('change', value);
}

export default {
	name: 'select-button',
	inheritAttrs: false,
	methods: {
		changeValue,
		sendValue,
	},
	props: {
		labelText: {
			default: '',
			type: String,
		},
		value: null,
	},
};
</script>





// WEBPACK FOOTER //
// select-button.vue?215aab16